<template>
  <div v-if="comesFromBackend"
       class="pb-4">
    <advice color="primary"
            v-if="comesFromBackendLoading">
      {{ $t('profile.changeUsername.validatingToken.loading') }}
    </advice>
    <advice color="success"
            v-else>
      {{ $t('profile.changeUsername.validatingToken.success') }}
    </advice>
  </div>
  <div v-else>
    <v-container>
      <advice color="primary" marginLeft="0px">
        <span class="caption grey--text text--darken-1">
          {{$t('profile.changeUsername.advice')}}
        </span>
      </advice>

      <v-form ref="form"
              class="mt-5"
              v-model="valid">
        <v-text-field :label="$t('global.placeholder.username')"
                      v-model="model.username"
                      value="user.username"
                      :rules='usernameRules'
                      :disabled="!editMode"
                      required></v-text-field>
      </v-form>
    </v-container>

    <v-card-actions class="px-4 pb-3">
      <v-spacer></v-spacer>
      <v-btn v-if="!editMode"
             flat
             color="primary"
             round
             outline
             class="initialize right"
             @click="editMode = !editMode">
        {{$t('global.button.edit')}}</v-btn>

      <v-btn v-if="editMode"
             flat
             color="primary"
             class="initialize right"
             @click=restoreForm>

        {{$t('global.button.cancel')}}</v-btn>
      <v-btn v-if="editMode"
             class="initialize right"
             round
             outline
             color="accent"
             :disabled='!valid'
             :loading="isLoading"
             @click="saveForm">
        {{$t('global.button.validate')}}</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import Advice from '@/components/commons/Advice';
import profileService from '@/services/profileService';
import manageErrorService from '@/services/manageErrorService';
import store from '@/store';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';

export default {
  name: 'ChangeUsername',
  components: {
    [Advice.name]: Advice
  },
  computed: {
    usernameRules() {
      return [
        v => !!v || this.$i18n.t('global.validation.required.text'),
        v => v.trim() !== store.state.user.username || this.$i18n.t('profile.changeUsername.validation.differentUsername'),
        v => /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/.test(v) || this.$i18n.t('global.validation.email.format')
      ]
    },
    token() {
      // Usado como callback de cambio de username
      return this.$route.query.token
    },
    username() {
      // Usado como callback de cambio de username
      return this.$route.query.username
    },
    newUsername() {
      // Usado como callback de cambio de username
      return this.$route.query.newUsername
    },
    comesFromBackend() {
      return this.newUsername && this.username && this.token
    },
    user() {
      return store.state.user
    }
  },
  data() {
    return {
      valid: false,
      editMode: false,
      isLoading: false,
      comesFromBackendLoading: true,
      model: {
        username: ''
      }
    };
  },
  created() {
    if (this.comesFromBackend) {
      this.validateToken()
    } else {
      this.loadForm();
    }
  },
  methods: {
    async validateToken() {
      let payload = {
        username: this.username,
        newUsername: this.newUsername.trim(),
        token: this.token
      }

      let results = await profileService.changeUsername(payload)
      if (results.error) {
        if (results.status === 401) {
          EventBus.$emit(keys.eventOnShowNotification, {
            message: this.$i18n.t('profile.changeUsername.toast.expiredToken'),
            type: 'warning',
            doNotTranslate: true
          })
          return
        }
        manageErrorService.handle(results.data);
        return;
      }

      store.commit('UPDATE_USERNAME', payload.newUsername);
      store.commit('UPDATE_TOKEN', results.data);
      store.commit('UPDATE_GO_TO_ROUTE_AFTER_LOGIN', { to: null });

      this.comesFromBackendLoading = false
    },
    loadForm() {
      this.model.username = this.user.username;
    },

    restoreForm() {
      this.loadForm();
      this.editMode = false;
    },

    async saveForm() {
      let isValidate = await this.$refs.form.validate();
      if (!isValidate) {
        return false;
      }

      // if (this.model.username.trim() === store.state.user.username) {
      //   EventBus.$emit(keys.eventOnShowNotification, {
      //     message: this.$i18n.t('profile.changeUsername.toast.sendToken', { username: store.state.user.username }),
      //     type: 'warning',
      //     doNotTranslate: true
      //   })
      //   return false
      // }

      this.isLoading = true;
      let params = {
        newUsername: this.model.username,
        city: store.state.citySelected.wspCity
      };

      let results = await profileService.requestChangeUsername(params);
      if (results.error) {
        manageErrorService.handle(results.data);
        return;
      }

      this.isLoading = false;

      EventBus.$emit(keys.eventOnShowNotification, {
          message: this.$i18n.t('profile.changeUsername.toast.sendToken', { username: store.state.user.username }),
          type: 'info',
          doNotTranslate: true
        })
    }
  }
};
</script>
